import React, { useEffect, useState, useMemo } from "react";
import DataTable, { createTheme } from "react-data-table-component";
import APIMiddleware from "../../../data/api/Api-Middleware.js";
import { API_ENDPOINT_GET_All_CLOSED_ORDERS } from "../../../data/Endpoints-API";
import { useAuthContext } from "../../../contexts/Auth-Context";
import { useChartContext } from "../../../contexts/Chart-Context.js";
import { adjustDateTime, formatDate, formatFilterDate, formatFilterDateOrPlaceholder, formatDigitBasePrice, formatFixedTrimmed } from "../../../utils/format.js";
import "./Positions.css";
import { useAccountManagerContext } from "../../../contexts/Account-Manager-Context.js";
import { useMetricsContext } from "../../../contexts/Metrics-Context.js";
import Select from "../../utils/Select.jsx";
import { CgSpinner } from "react-icons/cg";
import CellText from "./CellText.jsx";
import AppDatePicker, { TABLE_PERIOD_MIN_YEAR, parseLocalDate, anchorRectFromEvent } from "../../common/AppDatePicker.jsx";
import { useTranslation } from "react-i18next";
import { translateDirection } from "../../../i18n/directionLabel.js";
import { translateOrderStatus } from "../../../i18n/orderStatusLabel.js";
import NoRecordsMessage from "../../utils/NoRecordsMessage.jsx";
import { getPeriodOptions, findPeriodOption } from "../../../i18n/periodOptions.js";
import useTableHScrollPin from './useTableHScrollPin.js';
import { dropdownOptionStyle } from "../../../utils/dropdownOptionStyles.js";

const OrderHistory = ({name,parentRef, currTab, handleRowClick, isSymbolSelecting}) => {
  const { t } = useTranslation();
  const { utcOffset, userCurrencyExchangeRate } =  useMetricsContext();
  const { user, platFromData } = useAuthContext();
  const { setOrderHistoryCount,isOrderClosing } = useAccountManagerContext();
  const { selectedStyle } = useChartContext();
  const [radioChecked, setRadioChecked] = useState(true);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [selectDisabled2, setSelectDisabled2] = useState(false);
  const [selectDisabled, setSelectDisabled] = useState(false);
  const [symbolOrId, setSymbolOrId] = useState("");
  const [radioChecked2, setRadioChecked2] = useState(true);
  const [filter, setFilter] = useState("");
  const [selectedOrderDate, setselectedOrderDate] = useState("all");
  const [isCustomRangeSelected, setIsCustomRangeSelected] = useState(false);
  const [search, setSearch] = useState("");
  const [mobileMode, setMobileMode] = useState(false);
  const [expandedRows, setExpandedRows] = useState({});
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectedYear, setSelectedYear] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedDay, setSelectedDay] = useState('');
  const [activeDateField, setActiveDateField] = useState('start');
  const [pickerAnchorRect, setPickerAnchorRect] = useState(null);
  const [orderDate, setOrderDate] = useState({
    startDate: "2000-01-01 00:00:00",
    endDate: getTodaysEnd(),
  });
  const [datePickar, setDatePickar] = useState({
    startDate: "2000-01-01 00:00:00",
    endDate: getTodaysEnd(),
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isFetchingMore, setIsFetchingMore] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const bottomRef = React.useRef(null);
  const tableScrollRef = React.useRef(null);
  useTableHScrollPin(tableScrollRef);
  const enableInfiniteScroll = true;

  const monthNames = [
    'January','February','March','April','May','June',
    'July','August','September','October','November','December'
  ];

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 960) {
        setMobileMode(true);
        setPageSize(50);
      } else {
        setMobileMode(false);
        setPageSize(50);
      }
    };
    handleResize();  
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const customStyles = {
    headCells: {
      style: {
        justifyContent: 'flex-start !important',
        paddingLeft: '4px !important',
        paddingRight: '4px !important'
      },
    },
    cells: {
      style: {
        paddingLeft: '4px !important',
        paddingRight: '4px !important',
        justifyContent: 'flex-start !important',
        alignItems: 'center !important',
        textAlign: 'left !important',
        cursor: !mobileMode ? 'pointer' : undefined,
      },
    },
    pagination: {
      style: {
        minHeight: '30px',
        height: '30px'
      },
    },
    headRow: {
      style: {
        minHeight: '10px',
        height: '30px',
        backgroundColor: 'var(--surface-panel, #252b42)',
      },
      denseStyle: {
        minHeight: '10px',
        height: '30px'
      },
    },
  };
  const orderHistoryRowStyles = [
    {
      when: (row) => row.order_id != null && row.order_id === selectedRowId,
      classNames: ['am-row-selected'],
      style: {
        backgroundColor: '#323a54',
        color: 'var(--content-primary, #e8eaf0)',
        '&:hover': { backgroundColor: '#323a54' },
      },
    },
  ];
  createTheme(
    "solarized",
    {
      text: {
        primary: "var(--content-secondary, #b8bcc8)", // normalTextColor
      },
      background: {
        default: "var(--surface-panel, #252b42)", // firstBox
      },
      context: {
        background: "var(--surface-panel, #252b42)", // firstBox
        text: "var(--content-secondary, #b8bcc8)", // normalTextColor
      },
    },
    "dark"
  );

  const MobileOrderHistoryRow = ({ order, isExpanded, onToggle, name }) => {
      return (
        <div className={`mobile-position-row ${isExpanded ? 'expanded' : ''}`}>
          <div onClick={onToggle}>
            <div className="main-row">
              <div className="left-section">
                <div className="symbol-direction">
                  <span className="symbol-name">{order.symbol}</span>
                  <span
                    style={{
                      color:
                        order.direction?.toLowerCase() === 'buy'
                          ? selectedStyle.buyColor
                          : selectedStyle.sellColor
                    }}
                  >
                    {translateDirection(order.direction, t)}
                  </span>
                  <span className="quantity">{formatFixedTrimmed(Number(order.quantity), 8)}</span>
                </div>
                <div className="price-movement">
                  {formatFixedTrimmed(order.entry_price, 8)} → {formatFixedTrimmed(order.exit_price, 8) || '-'}
                </div>
              </div>
              <div className="status">
                {translateOrderStatus(order.status, t) || '---'}
              </div>
            </div>
            
            {isExpanded && (
              <div className="expanded-section">
                <div className="created-at">
                  <span className="label-open-time">{formatDate(adjustDateTime(order.created_at, utcOffset))}</span>
                </div>
              
                <div className="row">
                  <div className="half-row">
                    <span className="label">{t('tables.margin')}:</span>
                    <span className="value">{formatFixedTrimmed(order.margin, 4)}</span>
                  </div>
                  <div className="half-row">
                    <span className="label">ID:</span>
                    <span className="value">{`PID${order.order_id.toString().padStart(8, "0")}`}</span>
                  </div>
                </div>
              </div>          
            )}
          </div>
        </div>
      );
    };
  
    const MobileOrderHistoryList = ({ orders, name }) => {
      
      const toggleRow = (id) => {
        setExpandedRows(prev => ({
          ...prev,
          [id]: !prev[id]
        }));
      };    
    
      return (
        <div className="mobile-orders-container">
          {orders.map(order => (
            <MobileOrderHistoryRow
            name={name}
              key={`order-${order.id}`}
              order={order}
              isExpanded={expandedRows[order.id]}
              onToggle={() => toggleRow(order.id)}
            />
          ))}
        </div>
      );
    };

  function getTodaysEnd() {
    const today = new Date();

    // Set the time to the end of the day (23:59:59)
    today.setHours(23, 59, 59, 999); // Hours, minutes, seconds, milliseconds

    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Month (0-indexed) with leading zero
    const day = String(today.getDate()).padStart(2, "0");
    const hours = String(today.getHours()).padStart(2, "0");
    const minutes = String(today.getMinutes()).padStart(2, "0");
    const seconds = String(today.getSeconds()).padStart(2, "0");

    // Format the date and time in the desired format
    const formattedTimestamp = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    return formattedTimestamp;
  }

  function convertDatetime(datetimeString) {
    // Parse the date string using a date object
    const date = new Date(datetimeString);

    // Get year, month (0-indexed), day, hours, minutes, and seconds
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Add leading zero for single-digit months
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    // Format the date in the desired format
    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    return formattedDate;
  }

  useEffect(() => {
    const calculateRowsPerPage = () => {
      if (parentRef?.current) {
        const divHeight = parentRef.current.clientHeight;
        const rowHeight = 35;
        let rows;
        if (window.innerHeight < 960) {
          rows = Math.floor((divHeight * 0.6) / rowHeight);
        } else rows = Math.floor((divHeight * 0.8) / rowHeight);
      } else {
        setPageSize(10);
      }
    };
    // Call the function if currTab = history
    if (currTab === 'history') calculateRowsPerPage();
  }, [currTab, parentRef]);

  const mergeUniqueByKey = (baseArray, incomingArray, key) => {
    const map = new Map();
      for (const item of baseArray) {
        if (item && item[key] !== undefined && item[key] !== null) {
          map.set(item[key], item);
        }
      }
      for (const item of incomingArray) {
        if (item && item[key] !== undefined && item[key] !== null) {
          map.set(item[key], item);
        }
      }
      return Array.from(map.values());
  };
  const fetchPage = async (page = 1, append = false) => {
    var startDate = convertDatetime(orderDate.startDate);
    var endDate = convertDatetime(orderDate.endDate);
    if (isCustomRangeSelected) {
      if (!datePickar.startDate || !datePickar.endDate) return;
      startDate = convertDatetime(datePickar.startDate);
      endDate = convertDatetime(datePickar.endDate);
    }
    try {
      if (append) setIsFetchingMore(true);
      else setIsLoading(true);

      const response = await APIMiddleware.get(
        API_ENDPOINT_GET_All_CLOSED_ORDERS(
          user.userId,
          page,
          pageSize,
          search,
          startDate,
          endDate,
        ),
      );

      const respData = response.data || [];
      if (append) {
        setData(prev => mergeUniqueByKey(prev, respData, 'order_id'));
      } else {
        setData(respData);
      }

      setTotal(response.total || 0);
      setOrderHistoryCount(response.total || 0);

      const maxPage = Math.ceil((response.total || 0) / pageSize) || 1;
      setHasMore(page < maxPage);
    } catch (error) {
      console.error(error);
    } finally {
      if (append) setIsFetchingMore(false);
      else setIsLoading(false);
    }
  };

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      if (!isOrderClosing) {
        setCurrentPage(1);
        fetchPage(1, false);
      }
    }, 0);

    return () => clearTimeout(debounceTimer);
  }, [
    pageSize,
    filter,
    search,
    orderDate,
    datePickar,
    isCustomRangeSelected,
    platFromData[4]?.closedOrders,
  ]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const loadMore = () => {
    const maxPage = Math.ceil((total || 0) / pageSize) || 1;
    if (isFetchingMore || isLoading) return;
    if (currentPage >= maxPage) return;
    const nextPage = currentPage + 1;
    setCurrentPage(nextPage);
    fetchPage(nextPage, true);
  };

  useEffect(() => {
    if (!enableInfiniteScroll) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadMore();
          }
        });
      },
      { root: null, rootMargin: '200px', threshold: 0.1 },
    );

    const el = bottomRef.current;
    if (el) observer.observe(el);

    return () => {
      if (el) observer.unobserve(el);
      observer.disconnect();
    };
    
  }, [bottomRef, isFetchingMore, isLoading, currentPage, total, pageSize]);

  useEffect(() => {
    if (!enableInfiniteScroll || mobileMode) return;
    const scroller = tableScrollRef.current;
    if (!scroller) return;

    const onScroll = () => {
      if (isFetchingMore || isLoading) return;
      if (scroller.scrollHeight - scroller.scrollTop - scroller.clientHeight < 200) {
        loadMore();
      }
    };

    scroller.addEventListener('scroll', onScroll);
    return () => scroller.removeEventListener('scroll', onScroll);
  }, [mobileMode, isFetchingMore, isLoading, currentPage, total, pageSize, data.length]);

  const handleFilterChange = (value) => {
    setFilter(value);
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value); // Update search state
  };

  const columns = [
    {
      name: t('tables.id'),
      id: 'id',
      selector: (row) => row.order_id,
      grow: 0,
      minWidth: '108px',
      width: '108px',
      maxWidth: '108px',
      wrap: false,
      cell: (row) => <span className="cell-id">{row.order_id}</span>,
    },
    {
      name: t('tables.closeExpiredAt'),
      selector: (row) =>
        formatDate(adjustDateTime(row.created_at,utcOffset)),
      minWidth: '124px',
      grow: 1,
      wrap: false,
      cell: (row) => (
        <CellText text={formatDate(adjustDateTime(row.created_at, utcOffset))} />
      ),
    },
    {
      name: t('tables.symbol'),
      selector: (row) => row.symbol,
      grow: 1,
      minWidth: '72px',
      wrap: false,
      cell: (row) => <CellText text={row.symbol} />,
    },
    {
      name: t('tables.quantity'),
      selector: (row) => formatFixedTrimmed(row.quantity, 8),
      minWidth: '56px',
      grow: 1,
      wrap: false,
      cell: (row) => <CellText text={formatFixedTrimmed(row.quantity, 8)} />,
    },
    {
      name: t('tables.direction'),
      selector: (row) => row.direction,
      grow: 1,
      minWidth: '48px',
      wrap: false,
      cell: (row) => <CellText text={translateDirection(row.direction, t)} />,
    },
      {
          name: t('tables.margin'),
          selector: (row) => formatFixedTrimmed((row.margin * userCurrencyExchangeRate), 4),
          grow: 1,
          minWidth: '52px',
          wrap:false,
          cell: (row) => (
            <CellText text={formatFixedTrimmed((row.margin * userCurrencyExchangeRate), 4)} />
          ),
        },
    {
      name: t('tables.entry'),
      selector: (row) => {
        const entryPrice = parseFloat(row.entry_price);
        return isNaN(entryPrice) ? '---' : formatFixedTrimmed(row.entry_price, 8);
      },
      grow: 1,
      minWidth: '52px',
      wrap: false,
      cell: (row) => {
        const entryPrice = parseFloat(row.entry_price);
        return <CellText text={isNaN(entryPrice) ? '---' : formatFixedTrimmed(row.entry_price, 8)} />;
      },
    },
    {
      name: t('tables.exit'),
      selector: (row) => {
        const val = row.exit_price === null && row.status === 'filled' ? row.entry_price : row.exit_price;
        const exitPrice = parseFloat(val);
        return isNaN(exitPrice) ? '---' : formatFixedTrimmed(val, 8);
      },
      grow: 1,
      minWidth: '52px',
      wrap: false,
      cell: (row) => {
        const val = row.exit_price === null && row.status === 'filled' ? row.entry_price : row.exit_price;
        const exitPrice = parseFloat(val);
        return <CellText text={isNaN(exitPrice) ? '---' : formatFixedTrimmed(val, 8)} />;
      },
    },
    {
      name: t('tables.status'),
      selector: (row) => row.status,
      grow: 1,
      minWidth: '52px',
      wrap: false,
      cell: (row) => <CellText text={translateOrderStatus(row.status, t)} />,
    },
  ];
  const showEndRow = !mobileMode && !hasMore && !isFetchingMore && data.length > 0;
  const paginationComponentOptions = {
    noRowsPerPage: true,
  };
  const handleFirstDivClick = () => {
    setRadioChecked(true);
    setSelectDisabled(false); // Ensure select is enabled when clicking on the first div
  };
  const periodOptions = useMemo(() => getPeriodOptions(t), [t]);
  const [periodValue, setPeriodValue] = useState("all");
  const selectedOption = findPeriodOption(periodOptions, periodValue);

  const changehanldefunction = (option) => {
    if (!option) return;
    setPeriodValue(option.value);
    const value = option.value;

    if (value === "custom") {
      setIsCustomRangeSelected(true);
      setRadioChecked2(false);
      setDatePickar({ startDate: null, endDate: null });
      return;
    }

    setIsCustomRangeSelected(false);
    setRadioChecked2(true);

    if (value === "Today") {
      const today = new Date();
      const startDate = new Date(today).setHours(0, 0, 0, 0);
      const endDate = new Date(today).setHours(23, 59, 59, 999);
      setOrderDate({ startDate, endDate });
    } else if (value === "Yesterday") {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      const startDate = new Date(yesterday).setHours(0, 0, 0, 0);
      const endDate = new Date(yesterday).setHours(23, 59, 59, 999);
      setOrderDate({ startDate, endDate });
    } else if (value === "CurrentWeek") {
      const today = new Date();
      const startOfWeek = new Date(today.setDate(today.getDate() - today.getDay())).setHours(0, 0, 0, 0);
      const endOfWeek = new Date(today.setDate(today.getDate() - today.getDay() + 6)).setHours(23, 59, 59, 999);
      setOrderDate({ startDate: startOfWeek, endDate: endOfWeek });
    } else if (value === "CurrentMonth") {
      const today = new Date();
      const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1).setHours(0, 0, 0, 0);
      const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).setHours(23, 59, 59, 999);
      setOrderDate({ startDate: firstDayOfMonth, endDate: lastDayOfMonth });
    } else if (value === "PreviousMonth") {
      const today = new Date();
      const firstDayOfCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      const firstDayOfPreviousMonth = new Date(firstDayOfCurrentMonth).setMonth(firstDayOfCurrentMonth.getMonth() - 1);
      const lastDayOfPreviousMonth = new Date(firstDayOfCurrentMonth).setDate(0);
      setOrderDate({
        startDate: new Date(firstDayOfPreviousMonth).setHours(0, 0, 0, 0),
        endDate: new Date(lastDayOfPreviousMonth).setHours(23, 59, 59, 999),
      });
    } else if (value === "LastThreeMonth") {
      const today = new Date();
      const firstDateThreeMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 2, 1).setHours(0, 0, 0, 0);
      const lastDateCurrentMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).setHours(23, 59, 59, 999);
      setOrderDate({ startDate: firstDateThreeMonthsAgo, endDate: lastDateCurrentMonth });
    } else if (value === "Last6Month") {
      const today = new Date();
      const firstDateSixMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 5, 1).setHours(0, 0, 0, 0);
      const lastDateCurrentMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).setHours(23, 59, 59, 999);
      setOrderDate({ startDate: firstDateSixMonthsAgo, endDate: lastDateCurrentMonth });
    } else if (value === "all") {
      setOrderDate({ startDate: new Date("2000-01-01T00:00:00"), endDate: getTodaysEnd() });
    } else {
      setOrderDate({ startDate: new Date("2000-01-01T00:00:00"), endDate: getTodaysEnd() });
    }
  };
  const customStyle = {
    control: (provided, state) => ({
      ...provided,
      minHeight: '24px',
      height: '24px',
      width: '140px',
      minWidth: '140px',
      maxWidth: '140px',
      margin: 0,
      borderColor: state.isFocused
        ? `${selectedStyle.buyColor} !important`
        : 'var(--surface-border, #3a4156) !important',
      backgroundColor: 'var(--surface-panel, #252b42) !important',
      borderRadius: '6px',
      boxShadow: 'none',
      cursor: 'pointer',
      alignItems: 'center',
      boxSizing: 'border-box',
      '&:hover': {
        borderColor: `${selectedStyle.buyColor} !important`,
        boxShadow: 'none',
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      paddingLeft: '0',
      margin: '0',
      color: 'var(--content-secondary, #b8bcc8) !important',
      fontSize: '11px',
      lineHeight: '1',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0 2px 0 6px',
      height: '26px',
      display: 'flex',
      alignItems: 'center',
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: '26px',
      alignSelf: 'center',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      padding: '0 4px',
      color: state.isFocused || state.selectProps.menuIsOpen
        ? `${selectedStyle.buyColor} !important`
        : 'var(--content-secondary, #b8bcc8) !important',
      transition: 'color 0.15s ease',
      transform: 'none',
      '&:hover': {
        color: `${selectedStyle.buyColor} !important`,
      },
      svg: {
        width: '14px',
        height: '14px',
        transition: 'transform 0.2s ease',
        transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
        transformOrigin: 'center',
      },
    }),
    option: (provided, state) => dropdownOptionStyle(provided, state, {
      padding: '0 12px',
      height: '24px',
      minHeight: '24px',
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'center',
      fontSize: '11px',
      lineHeight: '1.35',
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: 'var(--surface-panel, #252b42) !important',
      margin: '0.3rem 0 0 0 !important',
      zIndex: 9999,
      overflow: 'hidden',
      borderRadius: '6px',
      border: '1px solid var(--surface-border, #3a4156)',
      boxShadow: 'none',
      minWidth: '140px',
      width: '140px',
      maxWidth: '140px',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '132px',
      minHeight: '3px',
      width: '100%',
      overflowY: 'auto',
      padding: '2px 0',
      scrollbarWidth: 'thin',
      scrollbarColor: 'rgba(170, 170, 170, 0.45) transparent',
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };
  return (
    <div className="history-section">
      <div className="bottom-table-bstorm">
        <div className="positions-button history-filters">
          <div className="hf-group hf-search">
            <div className="input-text">
              <input
                type="text"
                value={search}
                onChange={handleSearchChange}
                placeholder={t('tables.searchSymbol')}
              />
              <div className="input-svg" id="searchSvgColor">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="11"
                  height="11"
                  fill="currentColor"
                  className="bi bi-search"
                  viewBox="0 0 16 16"
                >
                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                </svg>
              </div>
            </div>
          </div>

          <div className="hf-group hf-time">
            <div className="hf-preset">
              <span className="hf-label">{t('filters.period')}</span>
              <Select
                options={periodOptions}
                value={selectedOption}
                onChange={changehanldefunction}
                styles={customStyle}
                isSearchable={false}
                classNamePrefix="history-period"
                menuPortalTarget={document.body}
              />
            </div>
            <div className={`hf-custom ${isCustomRangeSelected ? "" : "hf-hidden"}`}>
              <div className="date-time">
                <button
                  type="button"
                  className={`custom-date-button${showDatePicker && activeDateField === "start" ? " is-active" : ""}`}
                  title={formatFilterDateOrPlaceholder(datePickar.startDate)}
                  onClick={(e) => {
                    e.stopPropagation();
                    setActiveDateField("start");
                    setPickerAnchorRect(anchorRectFromEvent(e));
                    setShowDatePicker(true);
                  }}
                >
                  {formatFilterDateOrPlaceholder(datePickar.startDate)}
                </button>
                <span>–</span>
                <button
                  type="button"
                  className={`custom-date-button${showDatePicker && activeDateField === "end" ? " is-active" : ""}`}
                  title={formatFilterDateOrPlaceholder(datePickar.endDate)}
                  onClick={(e) => {
                    e.stopPropagation();
                    setActiveDateField("end");
                    setPickerAnchorRect(anchorRectFromEvent(e));
                    setShowDatePicker(true);
                  }}
                >
                  {formatFilterDateOrPlaceholder(datePickar.endDate)}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="table-scroll-area" ref={tableScrollRef}>
          {mobileMode ? (
            <div className="horizontal-scroll-wrapper">
              <MobileOrderHistoryList orders={data} name={name} />

              {total > 1 && !enableInfiniteScroll && (
                <div className="pagination-controls">
                  <button 
                    onClick={() => setCurrentPage(1)} 
                    disabled={currentPage === 1}
                    className="pagination-button"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M11.354 1.146a.5.5 0 0 1 0 .708L6.207 7l5.147 5.146a.5.5 0 0 1-.708.708l-5.5-5.5a.5.5 0 0 1 0-.708l5.5-5.5a.5.5 0 0 1 .708 0z"/>
                      <path d="M7.354 1.146a.5.5 0 0 1 0 .708L2.207 7l5.147 5.146a.5.5 0 0 1-.708.708l-5.5-5.5a.5.5 0 0 1 0-.708l5.5-5.5a.5.5 0 0 1 .708 0z"/>
                    </svg>
                  </button>
                  
                  <button 
                    onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} 
                    disabled={currentPage === 1}
                    className="pagination-button"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M11.354 1.146a.5.5 0 0 1 0 .708L6.207 7l5.147 5.146a.5.5 0 0 1-.708.708l-5.5-5.5a.5.5 0 0 1 0-.708l5.5-5.5a.5.5 0 0 1 .708 0z"/>
                    </svg>
                  </button>
                  
                  <button 
                    onClick={() => setCurrentPage(p => Math.min(p + 1, total))} 
                    disabled={currentPage === Math.ceil((total/pageSize))}
                    className="pagination-button"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M4.646 1.146a.5.5 0 0 1 .708 0l5.5 5.5a.5.5 0 0 1 0 .708l-5.5 5.5a.5.5 0 1 1-.708-.708L9.793 7 4.646 1.854a.5.5 0 0 1 0-.708z"/>
                    </svg>
                  </button>
                  
                  <button 
                    onClick={() => setCurrentPage(Math.ceil(total/pageSize))} 
                    disabled={currentPage === Math.ceil(total/pageSize)}
                    className="pagination-button"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M4.646 1.146a.5.5 0 0 1 .708 0L10.5 6.293 5.354 11.44a.5.5 0 0 1-.708-.708L9.293 7 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                      <path d="M8.646 1.146a.5.5 0 0 1 .708 0L14.5 6.293 9.354 11.44a.5.5 0 1 1-.708-.708L13.293 7 8.646 2.354a.5.5 0 0 1 0-.708z"/>
                    </svg>
                  </button>
                </div>
              )}

              {enableInfiniteScroll && (
                <>
                  <div ref={bottomRef} style={{ height: 30 }} />
                  {isFetchingMore && (
                    <div className="infinite-sentinel">
                      <CgSpinner color={selectedStyle.buyColor} size={20} className="spinner-rotate infinite-loader" />
                    </div>
                  )}
                  {!hasMore && !isFetchingMore && data.length > 0 && (
                    <div className="infinite-sentinel no-more-msg">
                      {t('tables.noMoreOrders')}
                    </div>
                  )}
                </>
              )}
            </div>
          ): (
            <div className="horizontal-scroll-wrapper">
              <DataTable
                className="history-rdt"
                columns={columns}
                data={data}
                pagination={false}
                filteringFunction={handleFilterChange}
                filtering={true}
                persistTableHead
                fixedHeader={true}
                theme="solarized"
                customStyles={customStyles}
                conditionalRowStyles={orderHistoryRowStyles}
                onRowClicked={(row) => {
                  if (row._endOfList) return;
                  setSelectedRowId(row.order_id);
                }}
                onRowDoubleClicked={(row) => {
                  if (row._endOfList) return;
                  handleRowClick(row);
                }}
                noDataComponent={<NoRecordsMessage />}
              />

              {showEndRow && <div className="no-more-inline">{t('tables.noMoreOrders')}</div>}
              {enableInfiniteScroll && hasMore && <div ref={bottomRef} style={{ height: 1 }} />}
              {isFetchingMore && enableInfiniteScroll && (
                <div className="infinite-sentinel">
                  <CgSpinner color={selectedStyle.buyColor} size={20} className="spinner-rotate infinite-loader" />
                </div>
              )}
            </div>
          )}
        </div>

        {showDatePicker && (
          <AppDatePicker
            open
            activeDateField={activeDateField}
            value={activeDateField === 'start' ? datePickar.startDate : datePickar.endDate}
            minYear={TABLE_PERIOD_MIN_YEAR}
            minDate={activeDateField === 'end' && datePickar.startDate ? datePickar.startDate : undefined}
            anchorRect={pickerAnchorRect}
            buyColor={selectedStyle?.buyColor}
            sellColor={selectedStyle?.sellColor}
            onCancel={() => setShowDatePicker(false)}
            onConfirm={(date) => {
              setDatePickar((prev) => {
                if (activeDateField === 'start') {
                  const start = parseLocalDate(date);
                  const end = parseLocalDate(prev.endDate);
                  const next = { ...prev, startDate: date };
                  if (end < start) {
                    const bumped = new Date(start);
                    bumped.setHours(23, 59, 59, 0);
                    next.endDate = bumped;
                  }
                  return next;
                }
                return { ...prev, endDate: date };
              });
              setShowDatePicker(false);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default OrderHistory;
